module.exports = __webpack_public_path__ + "media/post-listing-block-5-overlay-wide@2x.ce6d00cb.webp";